import {Component} from 'react';
import axios from "axios"
import Nav from "./../Nav";
import myconfig from "../../myconfig";

import {Line, Pie} from 'react-chartjs-2';
import {
    ArcElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from 'chart.js';
import Swal from "sweetalert2";

Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
let source = axios.CancelToken.source();

class DashOrder extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            objs: [],
            objsload: false,
            total:0,
            totalveh:0,
            assigned:0,
            assignedveh:0,
            notassigned:0,
            notassignedveh:0,
            today:0,
            todayveh:0,
        }
    }
    fetcheddata = () => {
        let baseurl = myconfig.dashboardorder;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsload: true,
                    total:res.data.total,
                    totalveh:res.data.totalveh,
                    assigned:res.data.assigned,
                    assignedveh:res.data.assignedveh,
                    notassigned:res.data.notassigned,
                    notassignedveh:res.data.notassignedveh,
                    today:res.data.today,
                    todayveh:res.data.todayveh,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentDidMount() {
         this.fetcheddata()
     }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    chartline7dayorder=()=> {
        let retdata = null;
        if(this.state.objsload) {
            let chartlables=new Array();
            let chartdata=new Array();
            for(let i=0; i<this.state.objs.sevenday.length; i++){
                chartlables.push(this.state.objs.sevenday[i].lable)
                chartdata.push(this.state.objs.sevenday[i].order)
            }
            let data = {
                labels: chartlables,
                datasets: [
                    {
                        label: "7 Day Order",
                        data: chartdata,
                        fill: true,
                        backgroundColor: "rgba(0,255,0,1)",
                        borderColor: "rgba(0,255,0,1)",
                    }
                ]
            };
            retdata = <Line data={data}/>;
        }
        return (<>{retdata}</>)
    }
    chartline7dayallocation=()=> {
        let retdata = null;
        if(this.state.objsload) {
            let chartlables=new Array();
            let chartdata=new Array();
            for(let i=0; i<this.state.objs.sevenday.length; i++){
                chartlables.push(this.state.objs.sevenday[i].lable)
                chartdata.push(this.state.objs.sevenday[i].allocation)
            }
            let data = {
                labels: chartlables,
                datasets: [
                    {
                        label: "7 Day Order",
                        data: chartdata,
                        fill: true,
                        backgroundColor: "rgba(0,255,0,1)",
                        borderColor: "rgba(0,255,0,1)",
                    }
                ]
            };
            retdata = <Line data={data}/>;
        }
        return (<>{retdata}</>)
    }
    chartpieassignedvsnotassigned=()=> {
        let data = {
            labels: ["Assigned","Not-Assigned"],
            datasets: [
                {
                    label: 'Assigned vs Not-assigned',
                    data: [this.state.assigned, this.state.notassigned],
                    backgroundColor: [
                        'rgba(0, 255, 0, 1)',
                        'rgba(255, 0, 0, 1)',
                    ],
                    borderColor: [
                        'rgba(0, 255, 0, 1)',
                        'rgba(255, 0, 0, 1)',
                    ],
                    borderWidth: 1,
                },
            ],
        };
        return (<>  <Pie data={data}/></>)
    }
    render() {
        return (
            <>
                <Nav type="dashorder"/>
                <div className="content-wrapper" style={{minHeight: '92px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Order vs Allocation</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Dashboard order</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-info">
                                        <div className="inner">
                                            <h3>{this.state.total} [q]</h3>
                                            <p>Total Order</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-bag"/>
                                        </div>
                                        <a href="#" className="small-box-footer">Near {this.state.totalveh} Truck</a>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-success">
                                        <div className="inner">
                                            <h3>{this.state.assigned} [q]</h3>
                                            <p>Assigned</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-bag"/>
                                        </div>
                                        <a href="#" className="small-box-footer">Near {this.state.assignedveh} Truck</a>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-danger">
                                        <div className="inner">
                                            <h3>{this.state.notassigned} [q]</h3>
                                            <p>Not-assigned</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-bag"/>
                                        </div>
                                        <a href="#" className="small-box-footer">Near {this.state.notassignedveh} Truck</a>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-secondary">
                                        <div className="inner">
                                            <h3>{this.state.today} [q]</h3>
                                            <p>Today Order</p>
                                        </div>
                                        <div className="icon">
                                            <i className="ion ion-bag"/>
                                        </div>
                                        <a href="#" className="small-box-footer">Near {this.state.todayveh} Truck</a>
                                    </div>
                                </div>
                            </div>
                            <div className="row">

                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                7 Day Order
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartline7dayorder()}
                                        </div>
                                    </div>
                                </section>
                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                7 Day Allocation
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartline7dayallocation()}
                                        </div>
                                    </div>
                                </section>
                                <section className="col-lg-6 connectedSortable ui-sortable">
                                    <div className="card">
                                        <div className="card-header ui-sortable-handle">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-pie mr-1"/>
                                                Assigned vs Not-assigned
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartpieassignedvsnotassigned()}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default DashOrder;
